import * as yup from "yup";
export const QuotationSchema = yup.object().shape({
  genrated_by: yup.string(),
  quotationDate: yup
    .date()
    .min(new Date(1950, 0, 1), "quotationDate must be after January 1, 1950")

    .required("Required"),
  costMarkupPercent: yup.number().min(0, "must be greter than or equal 0"),
  overrideUnitCost: yup.number().min(0, "must be greter than or equal 0"),
  overrideCostByPercent: yup
    .number()
    .min(-20, "must be greter than or equal -20")
    .max(100, "must be less than or equal 100"),
  maxDiscount: yup.number().min(0, "must be greater than or equal 0"),
  bay_size: yup
    .number()
    .typeError("Must be a number")
    .required("Required")
    .min(8, "Must be greater than or equal to 8")
    .test(
      "is-valid-bay",
      "Value must be (multiple of 4) + 4 (e.g., 8, 12, 16...)",
      (value) => {
        if (!value) return false;
        return (value - 4) % 4 === 0;
      }
    ),
  span_size: yup
    .number()
    .typeError("Must be a number")
    .required("Required")
    .min(12, "Must be greater than or equal to 12")
    .test(
      "is-valid-span",
      "Value must be (multiple of 8) + 4 (e.g., 12, 20, 28...)",
      (value) => {
        if (!value) return false;
        return (value - 4) % 8 === 0;
      }
    ),
  quotationType: yup
    .string()
    .required("Required")
    .oneOf(
      [
        "fanpad",
        "nvph",
        "nethouse",
        "fanpad with hydroponics",
        "nvph with hydroponics",
        "nethouse with hydroponics",
        "hydroponics only",
        "hydrobuild xs",
        "hydrobuild mini",
        "hydrobuild pro",
        "soilbasedfanpad",
        "soilbasednvph",
        "soilbasednethouse",
        null,
      ],
      "Invalid Type"
    ),
  a_FramePercent: yup
    .number()
    .min(0, "must be greter than or equal 0")
    .oneOf([0, 25, 50, 75, 100, null], "Invalid Type"),

  flatBedPercent: yup
    .number()
    .min(0, "must be greter than or equal 0")
    .oneOf([0, 25, 50, 75, 100, null], "Invalid Type"),

  growBagPercent: yup
    .number()
    .min(0, "must be greter than or equal 0")
    .oneOf([0, 25, 50, 75, 100, null], "Invalid Type"),

  dutchBucketPercent: yup
    .number()
    .min(0, "must be greter than or equal 0")
    .oneOf([0, 25, 50, 75, 100, null], "Invalid Type"),

  farmType: yup.string().oneOf(["indoor", "outdoor", null], "Invalid Type"),

  businessName: yup.string(),
  contactPersonName: yup.string().required("Required"),
  phoneNumber: yup.string().required("Required"),
  whatsAppNumber: yup.string(),
  contactPersonEmail: yup
    .string()
    .email("Please enter a valid email")
    .required("Required"),
  gstNumber: yup.string(),

  // .matches(
  //   /^([0-9]{2})([A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z]{1}[0-9]{1})$/,
  //   "GST number must be in the format 00AAAAA1234A0Z0"
  // ),
  address: yup.string().required("Required"),
  currencyCode: yup.string().oneOf(["INR", null], "Invalid Type"),
  showProjectFinancials: yup
    .boolean()

    .oneOf([true, false], "Invalid type"),
  finalQuotation: yup
    .boolean()

    .oneOf([true, false], "Invalid type"),
  notes: yup.string().min(10, "must be at least 10 characters"),
  addOnParticulars: yup.string(),
  addOnParticularsPrice: yup.number().when("addOnParticulars", {
    is: (val) => val,
    then: (s) => s.required("Field is required or remove addOnParticulars"),
    otherwise: (s) => s,
  }),
  isGrowSlab: yup.boolean().oneOf([true, false], "Invalid type"),
  isroundTop: yup.boolean().oneOf([true, false], "Invalid type"),
  termsAndConditions: yup.string(),
});
